import { createStore } from "vuex";
import {
  getAbonentInfo,
  getClientBalance,
  getNewStoriesApi,
  getPlansApi,
  getSubscriptionInfo,
  getUserInfo,
  postUserEvent,
} from "../components/ApiRequests";
import {
  isDev,
  getPayMethodCookie, getSawPayModalCookie,
} from "../components/Constants";

export default createStore({
  state: {
    abonentInfo: {},
    duration: 1,
    servicesSum: {},
    selectedServicesList: [],
    discounts: {},
    formattedServices: {},
    payMethod: "ls",
    userInfo: {},
    resumeButtonDisplay: false,
    payButtonDisplay: false,
    payModalDisplay: false,
    showLoaderStatus: true,
    stories: {},
    subscriptionInfo: {},
    balance: Number,
  },
  getters: {
    isAuthorityAbonentType(state) {
      const authorityTypes = ["vip", "free"];
      const abonentType = state.abonentInfo?.abonentType;

      return authorityTypes.includes(abonentType);
    },
  },
  mutations: {
    UPDATE_ABONENT_INFO(state, abonentInfo) {
      state.abonentInfo = abonentInfo;
    },
    CHANGE_DURATION(state, duration) {
      state.duration = duration;
    },
    CHANGE_SERVICES_SUM(state, servicesSum) {
      state.servicesSum = servicesSum;
    },
    CHANGE_SELECTED_SERVICES(state, selectedServicesList) {
      state.selectedServicesList = selectedServicesList;
    },
    CHANGE_DISCOUNTS(state, discounts) {
      state.discounts = discounts;
    },
    CHANGE_FORMATTED_SERVICES(state, formattedServices) {
      state.formattedServices = formattedServices;
    },
    CHANGE_PAY_METHOD(state, payMethod) {
      state.payMethod = payMethod;
    },
    UPDATE_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    UPDATE_PAY_BUTTON_DISPLAY(state, status) {
      state.payButtonDisplay = status;
    },
    UPDATE_PAY_MODAL_DISPLAY(state, status) {
      state.payModalDisplay = status;
    },
    UPDATE_RESUME_BUTTON_DISPLAY(state, status) {
      state.resumeButtonDisplay = status;
    },
    CHANGE_LOADER_STATUS(state, status) {
      state.showLoaderStatus = status;
    },
    GET_STORIES(state, stories) {
      state.stories = stories;
    },
    UPDATE_SUBSCRIPTION_INFO(state, subscriptionInfo) {
      state.subscriptionInfo = subscriptionInfo;
    },
    UPDATE_BALANCE(state, balance) {
      state.balance = balance;

    },
  },
  actions: {
    async getAbonentInfo(ctx) {
      const abonentInfo = await getAbonentInfo();

      ctx.commit("UPDATE_ABONENT_INFO", abonentInfo);
    },
    changeDuration(context, duration) {
      context.commit("CHANGE_DURATION", duration);
    },
    changeServicesSum(context, servicesSum) {
      context.commit("CHANGE_SERVICES_SUM", servicesSum);
    },
    changeSelectedServices(context, selectedServicesList) {
      context.commit("CHANGE_SELECTED_SERVICES", selectedServicesList);
    },
    changeDiscounts(context, discounts) {
      context.commit("CHANGE_DISCOUNTS", discounts);
    },
    changePayMethod(context, payMethod) {
      if (payMethod) {
        context.commit("CHANGE_PAY_METHOD", payMethod);
      } else {
        const payMethodCookie = getPayMethodCookie();
        if (payMethodCookie) {
          context.commit("CHANGE_PAY_METHOD", payMethodCookie);
        } else {
          const payMethod = this.state.abonentInfo ? "ls" : "card";
          context.commit("CHANGE_PAY_METHOD", payMethod);
        }
      }
    },
    async getPlans(context) {
      let services = await getPlansApi();
      const discounts = {};
      const selectedServicesList = [];

      services.forEach(duration => {
        Object.assign(discounts, {
          [duration["MONTH"]]: duration["PERCENT_DISCOUNT"],
        });
      });

      this.dispatch("changeDiscounts", discounts);

      services[0]["SERVICES"] = services[0]["SERVICES"].filter(service => {
        return +service.MONTH_PAY > 0
      });

      let formattedServices = services[0]["SERVICES"].map(service => {
        selectedServicesList.push(service.BASIC_SERVICE_ID);
        return {
          ID: service.BASIC_SERVICE_ID,
          SERVICE_NAME: service.SERVICE_NAME,
          MONTH_PAY: service.MONTH_PAY,
          UNCHANGEABLE: service.UNCHANGEABLE,
          HAS_SERVICE: service.HAS_SERVICE,
          SELECTED: true,
          PRICE: {},
        };
      });

      this.dispatch("changeSelectedServices", selectedServicesList);

      for (const [duration, discount] of Object.entries(discounts)) {
        Object.assign(this.state.servicesSum, {
          [duration]: 0,
        });

        const formattedServices1 = formattedServices.map(service => {
          const calcPrice = () => Math.ceil(service.MONTH_PAY * duration * (1 - discount / 100));
          this.state.servicesSum[duration] += calcPrice();

          return {
            ...service,
            PRICE: Object.assign(service.PRICE, { [duration]: calcPrice() }),
          };
        });

        context.commit("CHANGE_FORMATTED_SERVICES", formattedServices1);
      }
    },
    async getUserInfo(context) {
      const userInfo = await getUserInfo();

      context.commit("UPDATE_USER_INFO", userInfo);
    },
    async sendUserEvent(context, event) {
      if (isDev) {
        // eslint-disable-next-line no-console
        console.log(`Событие: ${event}`);
      } else {
        await postUserEvent(
          event,
          {
            "X-Api-User-Id": this.state.userInfo.USER_ID,
            "X-Device-Id": this.state.userInfo.UNIQUE_DEVICE_ID
          });
      }
    },
    changePayButtonDisplay(context, status) {
      context.commit("UPDATE_PAY_BUTTON_DISPLAY", status);
    },
    changePayModalDisplay(context, status) {
      context.commit("UPDATE_PAY_MODAL_DISPLAY", status);
    },
    changeResumeButtonDisplay(context, status) {
      context.commit("UPDATE_RESUME_BUTTON_DISPLAY", status);
    },
    changeLoaderStatus(context, status) {
      context.commit("CHANGE_LOADER_STATUS", status);
    },
    async getStories(context) {
      let stories = await getNewStoriesApi();

      let formattedStories = stories.map(story => {
        let splitUrl = story.url.split("/")
        let storiesId = splitUrl[splitUrl.length - 1]
        let mlUrl = `https://stories-ml.is74.ru/story/view-smart-yard?id=${storiesId}`

          return {
            id: story.id,
            image: story.image,
            url: story.url,
            mlUrl: mlUrl,
            mlId: storiesId
          }
      });

      context.commit("GET_STORIES", formattedStories);
    },
    async getSubscriptionInfo(ctx) {
      const subscriptionInfo = await getSubscriptionInfo();
      const balance = await getClientBalance();

      this.dispatch("getBalance", balance.BALANCE_CURR);

      if (subscriptionInfo.endDate) {
        this.dispatch("changeResumeButtonDisplay", true);
      } else if (!+subscriptionInfo.hasAccess || subscriptionInfo.creditTimeEnd || +balance.BALANCE_CURR < 0) {
        const sawPayModalCookie = getSawPayModalCookie();
        if (!sawPayModalCookie) {
          this.dispatch("changePayModalDisplay", true);
        }
        this.dispatch("changePayButtonDisplay", true);
      }
      ctx.commit("UPDATE_SUBSCRIPTION_INFO", subscriptionInfo);
      this.dispatch("changeLoaderStatus", false);
    },
    async getBalance(ctx, balance) {
      ctx.commit("UPDATE_BALANCE", balance);
    },

  },
  modules: {},
});
